let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9n2u9")).then(() => parcelRequire('4vSeO'));